import React from 'react';
import PropTypes from 'prop-types';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { BreadcrumbsContainer2 } from './CourseHome.styles';
import { EachSection } from './CourseHome.styles';
import DocumentationContainer from './CourseSections/Documentation.component';
import PresentationContainer from './CourseSections/Presentation.component';
import VideosContainer from './CourseSections/Videos.component';

const CourseDataDisplayed = ({ data }) => {
  return (
    <>
      <BreadcrumbsContainer2>
        <BreadCrumbs
          one="My Dashboard"
          oneLink="/user"
          two={data?.courseName}
        />
      </BreadcrumbsContainer2>
      <h2>{data?.courseName}</h2>
      <p>{data?.description}</p>
      <EachSection>
        <PresentationContainer data={data} />
      </EachSection>
      <EachSection>
        <DocumentationContainer data={data} />
      </EachSection>
      <EachSection>
        <VideosContainer data={data} />
      </EachSection>
    </>
  );
};

CourseDataDisplayed.propTypes = {
  data: PropTypes.shape({
    courseName: PropTypes.string,
    description: PropTypes.string,
    pdf: PropTypes.string,
    attachments: PropTypes.arrayOf(PropTypes.string),
    documentation: PropTypes.arrayOf(PropTypes.string),
    videoLinks: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default CourseDataDisplayed;
